import { render, staticRenderFns } from "./content-layout.vue?vue&type=template&id=4de23ce1&"
import script from "./content-layout.ts?vue&type=script&lang=ts&"
export * from "./content-layout.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports